import React from 'react';
import Scroll from 'react-scroll';
import DateTimePicker from 'react-datetime-picker';

import Const from '../../util/Constants';
import RegEx from '../../util/RegEx';
import DateUtil from '../../util/Util';

class FieldDate extends React.Component {
  
  constructor(props) {
    super(props);
    this.visible = props.field.visible === Const.True;
    this.editable = props.field.editable === Const.True;
    this.LabelName = props.field.label_name;
    this.regex = props.field.validate;
    this.Key = props.id;
    
    const date = DateUtil.serverStringDateTimeToDate(props.value);
    this.state = { value: date, inValid: this.props.inValid };
  }

  UNSAFE_componentWillReceiveProps(props) {
    const visible = props.field.visible === Const.True;
    const editable = props.field.editable === Const.True;
    if(props.value !== this.state.value || visible !== this.visible || editable !== this.editable) {
      this.visible = props.field.visible === Const.True;
      this.editable = props.field.editable === Const.True;
      this.LabelName = props.field.label_name;
      this.regex = props.field.validate;
      this.Key = props.id;
      const date = DateUtil.serverStringDateTimeToDate(props.value);
      this.setState({ ...this.state, value: date, inValid: props.inValid });
    }
  }

  handleChange = (date) => {
    let value = '';
    if(date !== null) { date.setHours(9); value = DateUtil.dateToServerDateTime(date); }
    let inValid = { };
    if(!RegEx.isDate(value, this.regex)) inValid[this.Key] = 'Invalid Data';
    this.props.onValueChange(this.Key, value);
    this.setState({ value: date, inValid: { ...inValid } });
  }

  render() {
    if(!this.visible || !this.editable) return null;

    let inValid = this.state.inValid;
    if(this.editable && RegEx.isKeyPresent(this.props.inValid, this.Key)) {
      inValid = this.props.inValid;
    }

    return (
      <div className="col">
        <div className="form-group">
          <Scroll.Element name={this.Key} />
          <label>{this.LabelName}</label> { RegEx.showError(inValid, this.Key) }
          <DateTimePicker  className={`custom-select ${RegEx.class(inValid, this.Key)}`}
            value={this.state.value} format="dd-MM-y" onChange={this.handleChange}
            disabled={!this.editable} />
        </div>
      </div>
    );
  }
}
export default FieldDate;